var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyrunInlineCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg9308",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 849.7 211.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.695 -10.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.687 10.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9289",
    fill: "none",
    stroke: "white",
    strokeMiterlimit: 22.926,
    strokeWidth: 9.73,
    d: "M192.96 89.28c2.86.72 6.92 2.93 9.2 4.3 5.092 3.461 4.42 3.23 7.62 5.75 5.242 4.854 8.4 8.79 11.18 15.06 11.32 25.48-6.76 54.68-38.55 59.69-8.11 1.28-19.14.71-27.65.71H70.03c-20.57 0-33.26 1.88-48.07-7.64-9.27-5.97-18.99-18.59-16.78-34.4 1.95-13.97 12.21-24.46 23.14-29.06.58-8 1.28-13.46 5.05-19.98 3.45-5.93 7.11-9.99 11.9-13.99 3.77-3.14 11.06-7.01 17.65-8.98 12.21-3.65 20.453-2.816 24.07-2.07C121.2 19.2 192.32 39.46 192.96 89.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9291",
    fill: "white",
    d: "M171.77 96.79c-8.13-.04-16.26-.08-20.73-.05-4.47.04-5.27.15-5.94.3-.66.16-1.17.36-1.69.7-.53.33-1.05.8-11.22 11.03-10.17 10.24-29.97 30.25-40.62 40.65-10.66 10.41-12.16 11.22-13.42 11.99-1.26.77-2.3 1.5-3.49 2.21-1.2.7-2.55 1.39-3.94 2.08-1.38.69-2.78 1.38-4.56 2.02-1.78.65-3.94 1.26-5.72 1.66-1.78.41-3.18.61-4.68.79-1.5.19-3.1.35-3.87.41s-.73.02 15.85 0 49.68-.01 66.23-.01l16.56.01c.01 0 .02 0 3.5-12.2s10.43-36.59 13.97-48.89c3.53-12.3 3.65-12.5 3.77-12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.687 10.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9294",
    d: "M431.64 75.99c2.99-2.94 6.74-5.56 9.32-8.61l6.71-6.41c1.56-1.33 1.23-.76 2.1-2.53h-32.25c-5.61 0-4.2-.72-9.82 4.65-1.25 1.2-2.01 2.4-3.23 3.61l-10.94 10.12c-3.76 3.49-4.72 5.73-7.33 6.78l.02-83.6-27.52.01v155.52l27.5.03v-25.81c0-6.4-1.07-7.05 2.31-10.58 2.08-2.18 3.84-4.98 6.38-6.38 4.92 5.28 26.69 34.05 33.35 42.74l33.06.03c-.83-1.53-1.86-2.64-2.92-4.02-1.12-1.45-1.91-2.58-2.93-3.93l-35.6-46.5c-1.94-2.47-3.71-5.21-6.02-7.58z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9296",
    d: "M459.19 58.55c.86 3.87 30.96 78.27 34.34 86.77.86 2.15 3.35 7.59 3.74 9.46.67 3.16-20.17 49.17-22.56 57.09l27.69-.02 61.53-153.03c-3.79-1.02-22.94-.47-28.03-.3l-24.42 60.33L487 58.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9298",
    d: "M781.9 155.55c.03-15.44.01-30.88 0-46.32-.01-9.85.02-11.52 4.78-18.23 7.13-10.04 23.75-9.94 31.69-.49 4 4.75 4.6 10.98 4.59 18.72-.02 15.39.01 30.79-.01 46.3l26.72.02v-44.22c0-7.73.35-12.55-1.72-20.4-2.97-11.28-9.47-19.23-18.01-25.67-8.63-6.49-24.4-10.65-34.66-7.79-4.86 1.35-11.3 5.32-13.35 7.8l-.02-6.84-26.46-.01.01 97.13z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9300",
    d: "M645.71 58.43c-.61 4.87-.14 12.94-.14 18.16 0 14.12-1.26 40.3 2.47 51.6 12.83 38.92 72.24 39.47 85.8-.06 5.8-16.91.05-56.66 2.87-69.69l-26.93.14c.04 15.3 0 30.61 0 45.91 0 7.69.43 14.21-3.62 19.66-7.8 10.48-24.77 9.07-30.79-.65-3.81-6.15-3.09-11.85-3.09-19.54 0-6.49.45-42.17-.25-45.53z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9302",
    d: "M328.51 89.24c2.65-2.27 5.33-6.01 7.76-8.64 1.61-1.74 2.3-2.9 3.64-4.26 1.74-1.77 2.22-2.36 3.64-4.49-3.37-4.63-14.89-9.94-20.95-11.92-32.8-10.74-59.31 14.57-46.33 40.04 8.85 17.38 33.44 14.97 44.25 20.99 6.27 3.49 2.46 14.33-14.42 12.21-3.83-.48-8.63-2.66-11.67-4.54-4.98-3.07-7.29-6.24-9.79-7.02-2.04 3.63-9.5 10.61-11.86 13.41-1.21 1.44-1.96 2.97-3.45 3.96 6.69 5.6 11.66 9.49 20.23 12.94 12 4.83 28.93 6.69 40.89-.28 9.64-5.62 15.49-12.84 16.28-24.7 1.71-25.51-21.9-28.41-39.81-33.46-4.1-1.15-10.08-2.03-10.36-6.42-.49-7.97 18.31-11.57 31.95 2.18z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9304",
    d: "M633.16 56.22c-9.2-.2-19.11.54-26.91 5.39-3.25 2.01-5 3.98-6.07 4.52l-.01-7.7-26.72.14v96.96l26.72.02-.01-50.03c.11-7.9 3.2-14.08 7.44-17.28 6.28-4.74 9.55-5.5 19.15-5.6z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyrunInlineCloud);
export default __webpack_public_path__ + "static/media/skyrun_inline_cloud.f8f3ed17306139c9010729a7db495c8a.svg";
export { ForwardRef as ReactComponent };